import BookmarkData from "../../interfaces/BookmarkData/BookmarkData";
import { CustomerData } from "../../interfaces/CustomerData/CustomerData";
// import { EHeaderShopCampaignData } from "../../interfaces/HeaderShopCampaign/EHeaderShopCampaign";
import IChampaignOrderShoppingCart from "../../interfaces/IChampaignOrderShoppingCart/IChampaignOrderShoppingCart";
import ProductProperties from "../../interfaces/ProductProperties/ProductProperties";
import LocalStorageProviderProps, { LocalStorageItems, LocalStorageItemsLastUpdated, LocalStorageLastUpdated } from "./LocalStorageProvider.props";
// import environment from '../EnvironmentProvider/EnvironmentProvider';

export class LocalStorageProvider {
    private props: LocalStorageProviderProps;
    private lastUpdated: LocalStorageLastUpdated;
    private warenkorbData: Array<ProductProperties>;
    private warenkorbDataCampaign: Array<IChampaignOrderShoppingCart>;
    private bookmarkData: BookmarkData;
    private customerData: CustomerData;
    private campaignId: string;
    private captchaToken: string;

    constructor(props: LocalStorageProviderProps) {
        this.props = props;
        this.lastUpdated = {};
        this.warenkorbData = [];
        this.warenkorbDataCampaign = [];
        this.bookmarkData = { produkte: []};
        this.customerData = {};
        this.campaignId = '';
        this.captchaToken = '';
        this.updateLocalStorageProvider();
    }

    private writeToLocalStorage(item: LocalStorageItems | string, itemLastUpdated: LocalStorageItemsLastUpdated, data: unknown) {
        // Automatically stringify non-string data. If data is already a string, store as-is.
        const dataString = typeof data === 'string' ? data : JSON.stringify(data);
        // TODO: Base64 Encoding
        // if(environment.isProductionBuild()) {
        //     const data = productInformationString;
        //     const buff = Buffer.from(data, 'base64');
        //     localStorage.setItem("warenkorb", buff as unknown as string);
        // } else {
        this.lastUpdated[itemLastUpdated] = Date.now();
        localStorage.setItem(itemLastUpdated, String(this.lastUpdated[itemLastUpdated]));
        localStorage.setItem(item, dataString);
        // }
    }

    updateLocalStorageProviderIfNeeded(item: LocalStorageItems, itemLastUpdated: LocalStorageItemsLastUpdated) {
        if (Number(localStorage.getItem(itemLastUpdated)) > (this.lastUpdated[itemLastUpdated] || Date.now())) {
            this.updateLocalStorageProvider();
        }
    }

    updateLocalStorageProvider() {
        const warenkorbData = localStorage.getItem(LocalStorageItems.CART) || "[]";
        const bookmarkData = localStorage.getItem(LocalStorageItems.BOOKMARK) || '{"produkte": []}';
        const customerData = localStorage.getItem(LocalStorageItems.CUSTOMER) || "{}";
        // TODO: Base64 Decoding
        // if(environment.isProductionBuild()) {
        //     const buff = Buffer.from(lsData, 'base64');
        //     lsData = buff.toString('utf8');
        // }

        let key: keyof typeof LocalStorageItemsLastUpdated;
        for (key in LocalStorageItemsLastUpdated) {
            this.lastUpdated[LocalStorageItemsLastUpdated[key]] = Number(localStorage.getItem(LocalStorageItemsLastUpdated[key]) || Date.now());
        }

        this.warenkorbData = JSON.parse(warenkorbData) as ProductProperties[];
        this.bookmarkData = JSON.parse(bookmarkData) as BookmarkData;
        this.customerData = JSON.parse(customerData) as CustomerData;
    }

    removeCustomerDataFromLocalStorage() {
        this.customerData = {};
        this.writeToLocalStorage(LocalStorageItems.CUSTOMER, LocalStorageItemsLastUpdated.CUSTOMERLASTUPDATED, this.customerData);
    }

    setCustomerDataInLocalStorage(customerData: CustomerData) {
        this.customerData = customerData;
        this.writeToLocalStorage(LocalStorageItems.CUSTOMER, LocalStorageItemsLastUpdated.CUSTOMERLASTUPDATED, this.customerData);
    }

    getCustomerDataFromLocalStorage(): CustomerData {
        this.updateLocalStorageProviderIfNeeded(LocalStorageItems.CUSTOMER, LocalStorageItemsLastUpdated.CUSTOMERLASTUPDATED);
        return this.customerData;
    }

    removeProductInformationFromLocalStorage(magicNumber?: string, index?: number, update = true) {
        this.updateLocalStorageProviderIfNeeded(LocalStorageItems.CART, LocalStorageItemsLastUpdated.CARTLASTUPDATED);

        if (magicNumber !== undefined) {
            this.warenkorbData.every((item, index) => {
                if (item.magicNumber === magicNumber) {
                    this.removeProductInformationFromLocalStorage(undefined, index);
                    return false;
                }

                return true;
            })
        }

        if (index !== undefined) {
            this.warenkorbData.splice(index, 1);
        }

        if (update) {
            this.writeToLocalStorage(LocalStorageItems.CART, LocalStorageItemsLastUpdated.CARTLASTUPDATED, this.warenkorbData);
        }
    }

    setProductInformationInLocalStorage(productProperties: ProductProperties) {
        // console.log('setProductInformationInLocalStorage() - productproperties', productProperties);
        this.updateLocalStorageProviderIfNeeded(LocalStorageItems.CART, LocalStorageItemsLastUpdated.CARTLASTUPDATED);
        let position = -1;

        // 1. check if there is a related product, the related product will be removed
        if (productProperties.blacklistIds) {
            // console.log('setProductInformationInLocalStorage() - has blackistIds', productProperties.blacklistIds);
            productProperties.blacklistIds.forEach(id => {
                this.warenkorbData.forEach((_item, index) => {
                    if (this.warenkorbData[index] && (id === this.warenkorbData[index].magicNumber)) {
                        // console.log('setProductInformationInLocalStorage(), has already a same product, this will be replaced', index);
                        position = index;
                        this.removeProductInformationFromLocalStorage(undefined, index, false);
                    }
                })
            })
        }

        // 2. check if same product is in the storage
        const existingProductPropertiesIndex = this.warenkorbData.findIndex(
            (productPropertiesFromLS) => productPropertiesFromLS.magicNumber === productProperties.magicNumber
        );

        if (existingProductPropertiesIndex >= 0) {
            this.warenkorbData[existingProductPropertiesIndex] = productProperties;
            // Place updated item to the end of the array
            this.warenkorbData.splice(this.warenkorbData.length - 1, 0, this.warenkorbData.splice(existingProductPropertiesIndex, 1)[0]);
            // console.log('setProductInformationInLocalStorage(), remove old product properties and add new to the end');
        } else {
            // console.log('setProductInformationInLocalStorage() - position', position);
            if (position >= 0) {
                // insert new product at the given position
                // console.log('setProductInformationInLocalStorage() - before inserting', this.warenkorbData);
                this.warenkorbData.splice(position, 0, productProperties);
                // console.log('setProductInformationInLocalStorage() - after inserting', this.warenkorbData);
            } else {
                this.warenkorbData.push(productProperties);
                // console.log('setProductInformationInLocalStorage(), added at the end');
            }
        }
        
        this.writeToLocalStorage(LocalStorageItems.CART, LocalStorageItemsLastUpdated.CARTLASTUPDATED, this.warenkorbData);
    }

    setProductInformationInLocalStorageCampaignOrder(productPropertiesArray: Array<ProductProperties>, campaignId: string, pageType: string) {
        // this.updateLocalStorageProviderIfNeeded(LocalStorageItems.CART, LocalStorageItemsLastUpdated.CARTLASTUPDATED);
        let currentShoppingCard = this.warenkorbDataCampaign.filter(data => data.shoppingCartId === `${pageType}_${campaignId}_${LocalStorageItems.CART}`);

        if (currentShoppingCard.length <= 0) {
            const newBasket = {
                shoppingCartId: `${pageType}_${campaignId}_${LocalStorageItems.CART}`,
                products: []
            }
            this.warenkorbDataCampaign.push(newBasket);
            currentShoppingCard = this.warenkorbDataCampaign.filter(data => data.shoppingCartId === `${pageType}_${campaignId}_${LocalStorageItems.CART}`);
        }

        productPropertiesArray.forEach((productProperties) => {
            if (productProperties.blacklistIds) {
                productProperties.blacklistIds.forEach(id => {
                    currentShoppingCard[0].products.forEach((item, index) => {
                        while (currentShoppingCard[0].products[index] && (id === currentShoppingCard[0].products[index].magicNumber)) {
                            this.removeProductInformationFromLocalStorage(undefined, index, false);
                        }
                    })
                })
            }

            const existingProductPropertiesIndex = currentShoppingCard[0].products.findIndex(
                (productPropertiesFromLS) => productPropertiesFromLS.magicNumber === productProperties.magicNumber
            );
    
            if (existingProductPropertiesIndex >= 0) {
                currentShoppingCard[0].products[existingProductPropertiesIndex] = productProperties;
                // Place updated item to the end of the array
                currentShoppingCard.splice(currentShoppingCard.length - 1, 0, currentShoppingCard.splice(existingProductPropertiesIndex, 1)[0]);
            } else {
                currentShoppingCard[0].products.push(productProperties);
            }
        })

        this.writeToLocalStorage(`${pageType}_${campaignId}_${LocalStorageItems.CART}`, LocalStorageItemsLastUpdated.CARTLASTUPDATED, currentShoppingCard[0].products);
    }

    getProductInformationForCampaingOrder(campaignId: string, pageType: string) {
        const cartData = localStorage.getItem(`${pageType}_${campaignId}_${LocalStorageItems.CART}`);
        if (!cartData) {
            return;
        }
        return JSON.parse(cartData) as Array<ProductProperties>;
    }


    removeProductInformationFromCampaignOrderCartByMagicNumber(campaignId: string, pageType: string, magicNumber: string) {
        const cartData = localStorage.getItem(`${pageType}_${campaignId}_${LocalStorageItems.CART}`);
        if (!cartData) {
            return;
        }
        
        const arrayFromCartData = JSON.parse(cartData);

        const filteredCartData = arrayFromCartData.filter((item: ProductProperties, index: number) => {
            return item.magicNumber !== magicNumber;
        })

        this.clearProductInformationCampaignOrderInLocalStorage(campaignId, pageType);
        this.writeToLocalStorage(`${pageType}_${campaignId}_${LocalStorageItems.CART}`, LocalStorageItemsLastUpdated.CARTLASTUPDATED, filteredCartData);
        return filteredCartData;
    }

    getProductInformationFromLocalStorage(magicNumber?: string): { productProperties?: ProductProperties, warenkorbData: ProductProperties[] } | undefined {
        return {
            productProperties: magicNumber ? this.warenkorbData.find((productProperties) => productProperties.magicNumber === magicNumber) : undefined,
            warenkorbData: this.warenkorbData
        }
    }

    getProductInformationFromLocalStorageCampaignOrder(campaignId: string, pageType: string, magicNumber?: string): { productProperties?: ProductProperties, warenkorbData: ProductProperties[] } | undefined {
        const cartData = localStorage.getItem(`${pageType}_${campaignId}_${LocalStorageItems.CART}`);
        if (!cartData) {
            return;
        }
        let products = this.warenkorbDataCampaign.filter(data => data.shoppingCartId === `${pageType}_${campaignId}_${LocalStorageItems.CART}`)[0]?.products;
        // console.log('products: ', this.warenkorbDataCampaign);
        if (!products) {
            products = JSON.parse(cartData) as Array<ProductProperties>
        }
        return {
            productProperties: magicNumber ? products.find((productProperties) => productProperties.magicNumber === magicNumber) : undefined,
            warenkorbData: products
        }
    }

    clearProductInformationInLocalStorage() {
        this.writeToLocalStorage(LocalStorageItems.CART, LocalStorageItemsLastUpdated.CARTLASTUPDATED, []);
        this.updateLocalStorageProvider();
    }

    clearProductInformationCampaignOrderInLocalStorage(campaignId: string, pageType: string) {
        // this.writeToLocalStorage(`${pageType}_${campaignId}_${LocalStorageItems.CART}`, LocalStorageItemsLastUpdated.CARTLASTUPDATED, []);
        localStorage.removeItem(`${pageType}_${campaignId}_${LocalStorageItems.CART}`);
        this.updateLocalStorageProvider();
    }

    clearCustomerDataInLocalStorage() {
        this.writeToLocalStorage(LocalStorageItems.CUSTOMER, LocalStorageItemsLastUpdated.CUSTOMERLASTUPDATED, {});
        this.updateLocalStorageProvider();
    }

    getBookmarkDataFromLocalStorage(): BookmarkData {
        this.updateLocalStorageProviderIfNeeded(LocalStorageItems.BOOKMARK, LocalStorageItemsLastUpdated.BOOKMARKLASTUPDATED);
        return this.bookmarkData;
    }

    addBookmarkDataToLocalStorage(productNumber: number): void {
        if (this.bookmarkData.produkte.indexOf(productNumber) === -1) {
            this.bookmarkData.produkte.push(productNumber);
            this.writeToLocalStorage(LocalStorageItems.BOOKMARK, LocalStorageItemsLastUpdated.BOOKMARKLASTUPDATED, this.bookmarkData);
        }
    }

    setCampaignInLocalStorage(campaignId: string) {
        if(campaignId) {
            this.campaignId = campaignId;
            // campaignId is a string; writeToLocalStorage will store it without JSON.stringify
            this.writeToLocalStorage(LocalStorageItems.CAMPAIGN, LocalStorageItemsLastUpdated.CAMPAIGNLASTUPDATED, this.campaignId);
        }
    }

    getCampaignFromLocalStorage(): string | null{
        return localStorage.getItem(LocalStorageItems.CAMPAIGN);
    }

    setCaptchaTokenInLocalStorage(captchaToken: string) {
        this.captchaToken = captchaToken;
        this.writeToLocalStorage(LocalStorageItems.CAPTCHA, LocalStorageItemsLastUpdated.CAPTCHALASTUPDATED, this.captchaToken);
    }

    getCaptchaTokenFromLocalStorage(): string {
        this.updateLocalStorageProviderIfNeeded(LocalStorageItems.CAPTCHA, LocalStorageItemsLastUpdated.CAPTCHALASTUPDATED);
        return this.captchaToken;
    }

    removeCaptchaTokenFromLocalStorage() {
        this.captchaToken = '';
        this.writeToLocalStorage(LocalStorageItems.CAPTCHA, LocalStorageItemsLastUpdated.CAPTCHALASTUPDATED, this.captchaToken);
    }
}

const localStorageProvider = new LocalStorageProvider({});
export default localStorageProvider;
